// @ts-nocheck
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostBinding,
  HostListener,
  AfterViewInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import * as d3 from "d3";

import { IconChartComponent } from '../iconEvent-chart/icon-chart.component';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';


import patientJourneyData from "src/app/components/shared/charts/pixel-map/patient_journey_data_super_shortened.json"
import journeyStopData from "src/app/components/shared/charts/pixel-map/sequencing_min_stat_source_cnt.json";
@Component({
    selector: 'app-upset-chart',
    templateUrl: './upset-chart.component.html',
    styleUrls: ['./upset-chart.component.scss'],
    standalone: false
})
export class UpsetChartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  // ===================================================================
  // Component Properties
  // ===================================================================

  // A reference to the chart's container element in the template.
  @ViewChild('UpsetChartContainer') UpsetChartContainer: ElementRef;
  @ViewChild('fs') fs: ElementRef;


  @ViewChild(IconChartComponent) iconChart!: IconChartComponent;
  @Input('item') item: any
  @Input('type') type: any
  @Input('data') data: any
  @Input('columnDetails') columnDetails: any
  @Input('config') config: any
  @Input('heading') heading: string = ''
  @Input('pageKey') pageKey: any
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  reqSubcription: Subscription[] = [];

  moduleName: any;
  cardName: any;

  divId: any = "UpsetChartDiv";
  iconList: any;
  isActive = false;
  props: any = {};
  initialChartWidth: any;
  cardWidthWithoutScrolling: any;

  // Holds the transformed data ready for D3 to use.
  private processedData: any[];
  // Holds the unique list of all possible statuses for the matrix y-axis.
  private sets: string[];
  // Holds the total number of unique patients for percentage calculations.
  private totalPatients: number;
  // Tracks which bars are currently selected by the user.
  private selectedBars = new Set<string>();

  // Controls the expanded state of the chart for the "Show More" feature.
  public showMore = false;
  // Determines if the "Show More" button should be visible.
  public isOverflowing = false;
  // track filtered state
  private isFiltered = false;

  private componentId: string;
  private matrixYaxisVar: string;
  private patientIdFilter: Set<string> | null = null; // Stores patient IDs from the other chart


  private barSvg: d3.Selection<SVGGElement, unknown, null, undefined>;
  private matrixSvg: d3.Selection<SVGGElement, unknown, null, undefined>;
  private barGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  private matrixGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  private yAxisTitle: d3.Selection<SVGTextElement, unknown, null, undefined>;

  constructor(
    private cdr: ChangeDetectorRef,
    private newFilterService: NewFilterService,
    public filterService: FilterService,
    private route: ActivatedRoute,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService) {
    this.filterService.changeDisplays.subscribe((res: any) => {
      // gets the value of the selected toggle from the icon chart 
      if (this.item.config.report_heading == "Sources") {
        this.changeDisplayType(res);
      }
    });

    // This is used for setting up the route to the pixel map
    this.route.params.subscribe((p: any) => {
      this.queryParams = p;
      this.moduleName = p['module'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  // ===================================================================
  // Angular Lifecycle Hooks
  // ===================================================================

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      console.log('[UpsetChart] Data changed, reprocessing...');
      if (this.matrixYaxisVar == "JOURNEY_STOP") {
        this.processJourneyStopData();
      } else {
        this.processData();
      }
      this.drawChart();
    }
  }

  ngOnInit(): void {
    console.log(journeyStopData);
    // Process the raw data once when the component is initialized.
    this.iconList = this.item?.config.icon ? this.item?.config.icon : this.iconList

    // Make sure we are subscribed to chart changes. Needed for our double upsetChart dashboard
    this.componentId = `${this.item?.config?.report_heading}:${Math.random()} `

    this.reqSubcription.push(
      this.newFilterService.upsetChartFilteredData.subscribe((payload: any) => {
        if (payload && payload.senderId !== this.componentId) {
          // Store the list of patient IDs from the other chart
          this.patientIdFilter = payload.data;
          // Reprocess and redraw this chart with the filtered data
          this.processData();
          this.drawChart();
          this.cdr.detectChanges();
        }
      }));


    this.matrixYaxisVar = this?.item?.config?.y_axis ?? "CURRENT_REFERRAL_STATUS";

    // Initial processing
    if (this.matrixYaxisVar == "JOURNEY_STOP") {
      this.processJourneyStopData();
    } else {
      this.processData();
    }
  }

  ngAfterViewInit(): void {
    // Perform the initial chart render after the view (and #chartContainer) is ready.
    this.setupChart();
    this.drawChart();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Redraw the chart whenever the window is resized to keep it responsive.
    this.drawChart();
  }


  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  closeFullscreen(): void {
    this.isFullscreen = false;
    this.props.chartHeight = 400
    this.cardWidthWithoutScrolling = this.initialChartWidth;
    this.isActive = false;

    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } 
    setTimeout(() => {
      this.drawChart();
    }, 100);
  }

  openFullscreen(): void {
    this.isFullscreen = true;
    const el = this.fs.nativeElement;
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
      }
    }
    setTimeout(() => {
      this.isActive = true;
      this.isFullscreen = true;
      this.drawChart();
    }, 500);
    setTimeout(() => { }, 500);
  }

  changeDisplayType(selectedType: any) {
    this.matrixYaxisVar = selectedType;
    if (this.matrixYaxisVar == "JOURNEY_STOP") {
      this.processJourneyStopData();
    }
    else {
      this.processData();
    }
    this.drawChart();
    // this.changeChartTheme(selectedType);
  }

  // ===================================================================
  // Public Component Methods (for the template)
  // ===================================================================

  /**
   * Toggles the expanded state of the chart and triggers a redraw.
   */
  public toggleShowMore(): void {
    this.showMore = !this.showMore;
    this.drawChart();
  }

  /**
   * When the user clicks "Filter", the behavior depends on which chart this is.
   */
  public filterData(): void {
    if (this.selectedBars.size === 0) return;

    // Use the helper method to find all patient IDs that match the current selections.
    const patientIdsToBroadcast = this.findMatchingPatientIds();

    // Broadcast the list of patient IDs TO the other chart.
    this.sendPatientFilter(patientIdsToBroadcast);

    // Set the CURRENT chart to its filtered state and redraw it.
    this.isFiltered = true;
    this.drawChart();
  }

  /**
   * ✅ New private helper method to find matching patient IDs based on the current selections.
   * This avoids duplicating code for both the 'Sources' and 'Statuses' charts.
   * @returns A Set of patient IDs that match the selected bar combinations.
   */
  private findMatchingPatientIds(): Set<string> {
    const selectedCombinations = new Set(Array.from(this.selectedBars));
    const matchingPatientIds = new Set<string>();
    const patientValueSets = new Map<string, Set<string>>();
    const dataField = this.matrixYaxisVar; // The field to group by (e.g., 'SOURCE_NAME')

    // 1. Group the relevant data (statuses or sources) for each patient in the raw dataset.
    // 1. Group the relevant data (statuses or sources) for each patient in the raw dataset.
    // Check if `this.data` exists AND has the expected structure for Patient Journey data.
    const isDynamicDataValid = this.data && this.data.length > 0 && 'LH_PATIENT_ID' in this.data[0];
    const rawData = isDynamicDataValid ? this.data : patientJourneyData;

    rawData.forEach((record: any) => {
      // Apply the same deterministic "fluffing" filter here so filtering matches the chart.
      if (!this.shouldIncludeRecord(record)) return;

      const value = record[dataField];
      if (value) {
        if (!patientValueSets.has(record.LH_PATIENT_ID)) {
          patientValueSets.set(record.LH_PATIENT_ID, new Set());
        }
        patientValueSets.get(record.LH_PATIENT_ID).add(value);
      }
    });

    // 2. Check each patient's combination of values against the user's selections.
    patientValueSets.forEach((values, patientId) => {
      let key;
      // This logic MUST match the key generation in processData() to find a match.
      if (dataField === 'CURRENT_REFERRAL_STATUS') {
        const customStatusOrder = ['PENDING', 'CANCELLED', 'CANCELLED - TRANSITION', 'ACTIVE', 'DISCONTINUED', 'QUICK START', 'PAP', 'IAP', 'INACTIVE', 'NURSING'];
        key = Array.from(values).sort((a, b) => {
          const indexA = customStatusOrder.indexOf(a);
          const indexB = customStatusOrder.indexOf(b);
          if (indexA === -1) return 1; if (indexB === -1) return -1;
          return indexA - indexB;
        }).join('-');
      } else {
        key = Array.from(values).sort().join('-');
      }

      // If the patient's combination key is in the set of selected bars, add their ID.
      if (selectedCombinations.has(key)) {
        matchingPatientIds.add(patientId);
      }
    });

    return matchingPatientIds;
  }

  /**
   * Resets this chart and tells the other chart to reset its filter.
   */
  public resetChart(): void {
    this.selectedBars.clear();
    this.isFiltered = false;
    this.showMore = false;

    // Reset the filter that this chart might have received from the other chart.
    this.patientIdFilter = null;

    // Tell the other chart to reset its filter as well.
    this.sendPatientFilter(null);

    // CRUCIAL: Reprocess the data using the full, original dataset.
    this.processData();

    // Now, redraw the chart with the reprocessed, full data.
    this.drawChart();
    this.cdr.detectChanges();
  }


  public goToPixelMap(event): void {
    console.log("arrow clicked");

    let patientIdsToBroadcast: any;

    // Check if we are in "Sources" mode (where we have `id` in processedData)
    const isSourcesMode = this.processedData && this.processedData.length > 0 && 'id' in this.processedData[0];

    if (isSourcesMode) {
      // Find the selected item(s) in processedData
      const selectedKeys = Array.from(this.selectedBars);
      if (selectedKeys.length > 0) {
        // Find all matching items in processedData
        const matchingItems = this.processedData.filter(item => {
          const key = item.sets.join('-');
          return this.selectedBars.has(key);
        });

        // Extract IDs (pat_seq_sub_cat_key)
        patientIdsToBroadcast = matchingItems.map(item => item.id);
        console.log("Selected Sources Keys:", patientIdsToBroadcast);
      } else {
        patientIdsToBroadcast = null;
      }
    } else {
      // Use the helper method to find all patient IDs that match the current selections.
      patientIdsToBroadcast = Array.from(this.findMatchingPatientIds());
    }

    this.NavigationArrow('chart', patientIdsToBroadcast, event.offsetX, event.offsetY, 500)
  }

  private NavigationArrow(myType: any, myData: any, myX: any, myY: any, chartWidth: any): void {
    // Navigation taken from horizontal-bar-chart.component.ts
    const conf0 = this.item.config?.['nav_configuration'].controls[0]
    let nav = {
      dbJSON: conf0.dbJSON,
      s3JSON: conf0.s3JSON,
      pageName: conf0.pageName,
      isDashboardLevel: conf0.isDashboardLevel
    }

    // let payload:any ={[conf0.payloadData]:conf0.payloadData=='column_key'? myData[0].AllData[0][conf0.payloadData] : myData[0].range }
    let payload = { [conf0?.payloadData]: myData?.join(',') ?? null };
    this.routerHandlerService.navDetailInfo(nav);
    this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, payload, '');

    let query: any = Object.assign({}, this.decryptedParams, { tab_id: 0 }, { page: 'card' });
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
  }

  /**
   * Generates the text for the selection counter display.
   * @returns A formatted string like "2 Archetypes Selected".
   */
  public getSelectionText(): string {
    const count = this.selectedBars.size;
    if (count === 0) {
      return '';
    }
    const noun = count === 1 ? 'Archetype' : 'Archetypes';
    return `${count} ${noun} Selected`;
  }

  /**
   * Broadcasts a set of patient IDs (or null to reset) to other components.
   */
  sendPatientFilter(patientIdSet: Set<string> | null): void {
    const payload = {
      senderId: this.componentId,
      data: patientIdSet
    };
    this.newFilterService.upsetChartFilteredData.next(payload);
  }

  setupChart(): void {
    const element = this.UpsetChartContainer.nativeElement;
    d3.select(element).selectAll('*').remove();

    const margin = { top: 0, right: 30, bottom: 0, left: 160 };

    // 1. Top Container for Bar Chart
    const barContainer = d3.select(element).append("div")
      .attr("class", "chart-section bar-section")
      .style("width", "100%")
      .style("overflow", "hidden"); // No scroll for bars

    this.barSvg = barContainer.append("svg")
      .append("g")
      // Translate down to leave space for the bars to grow upwards
      .attr("transform", `translate(${margin.left}, 350)`);

    this.barGroup = this.barSvg.append("g").attr("class", "bar-group");

    // Add the Y-axis title to the bar SVG
    this.yAxisTitle = this.barSvg.append("text")
      .attr("class", "y-axis-title")
      .attr("transform", "rotate(-90)")
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text("Patient Volume and Percentage");

    // 2. Bottom Container for Matrix
    const matrixContainer = d3.select(element).append("div")
      .attr("class", "chart-section matrix-section");
    // Styles are now handled in SCSS for consistency

    this.matrixSvg = matrixContainer.append("svg")
      .append("g")
      .attr("transform", `translate(${margin.left}, 10)`); // Small top padding

    this.matrixGroup = this.matrixSvg.append("g").attr("class", "matrix-group");
  }

  // ===================================================================
  // Data Processing Method
  // ===================================================================

  /**
   * Processes the raw patient journey data into a format suitable for the UpSet chart.
   * This method runs only once.
   */

  /**
   * Helper to deterministically filter records for "Journey Stop" view to create variety.
   * Returns true if the record should be included.
   */
  private shouldIncludeRecord(record: any): boolean {
    // Only apply this logic for Journey Stop view
    if (this.matrixYaxisVar !== 'JOURNEY_STOP') return true;

    const patientId = parseInt(record.LH_PATIENT_ID, 10);
    const stop = record.JOURNEY_STOP;

    // Always keep HUB
    if (stop === 'HUB') return true;

    // Deterministic logic based on patient ID
    // Group 0 (33%): Keep everything
    // Group 1 (33%): Drop 'Non-COMMERCIAL SPs'
    // Group 2 (33%): Drop 'COMMERCIAL SPs'
    const group = patientId % 3;

    if (group === 1 && stop === 'Non-COMMERCIAL SPs') return false;
    if (group === 2 && stop === 'COMMERCIAL SPs') return false;

    return true;
  }

  processData(): void {
    // =================================================================
    // NEW: Check for pre-aggregated "Sources" data structure
    // =================================================================
    // CRITICAL FIX: Only use this logic if we are NOT in "Journey Stop" or "Statuses" mode.
    // Those modes require raw patient journey data (or the static fallback), even if "Sources" data is loaded.
    if (this.matrixYaxisVar !== 'JOURNEY_STOP' && this.matrixYaxisVar !== 'CURRENT_REFERRAL_STATUS' &&
      this.data && this.data.length > 0 && 'sub_category_desc' in this.data[0]) {
      // 1. Transform the data into the structure required by drawChart()
      this.processedData = this.data.map((item: any) => ({
        // Split the sequence string into an array of stops (comma-separated)
        sets: item.sub_category_desc.split(',').map((s: string) => s.trim()),
        // Use the patient count from the API
        count: item.pat_count,
        // Preserve the key for navigation
        id: item.pat_seq_sub_cat_key
      }))
        .sort((a: any, b: any) => b.count - a.count); // Sort by count descending

      // 2. Calculate the total patient count for percentage calculations
      this.totalPatients = this.processedData.reduce((sum, item) => sum + item.count, 0);

      // 3. Get all unique sources for the Y-axis labels
      const allStops = new Set<string>();
      this.processedData.forEach(item => {
        item.sets.forEach(stop => allStops.add(stop));
      });
      this.sets = Array.from(allStops).sort(); // Sort alphabetically
      return;
    }

    // =================================================================
    // KEY CHANGE 1: The entire function now operates on `sourceData`.
    // If `patientIdFilter` exists, `sourceData` is a smaller, filtered array.
    // If not, it's the full original dataset.
    // =================================================================
    // Check if `this.data` exists AND has the expected structure for Patient Journey data.
    const isDynamicDataValid = this.data && this.data.length > 0 && 'LH_PATIENT_ID' in this.data[0];
    const rawData = isDynamicDataValid ? this.data : patientJourneyData;

    if (!rawData) return;

    const sourceData = this.patientIdFilter
      ? rawData.filter((record: any) => this.patientIdFilter!.has(record.LH_PATIENT_ID))
      : rawData;

    const customStatusOrder = [
      'PENDING', 'CANCELLED', 'CANCELLED - TRANSITION', 'ACTIVE', 'DISCONTINUED',
      'QUICK START', 'PAP', 'IAP', 'INACTIVE', 'NURSING'
    ];

    // Step 1: Group unique values for each patient from the correct data source.
    const patientValueSets = new Map<string, Set<string>>();
    sourceData.forEach((record: any) => { // <-- Using `sourceData` here is critical.
      // Apply deterministic "fluffing" filter to create variety in Journey Stop view
      if (!this.shouldIncludeRecord(record)) return;

      const patientId = record.LH_PATIENT_ID;
      const value = record[this.matrixYaxisVar];
      if (value) {
        if (!patientValueSets.has(patientId)) {
          patientValueSets.set(patientId, new Set<string>());
        }
        patientValueSets.get(patientId)!.add(value);
      }
    });

    // =================================================================
    // KEY CHANGE 2: The total patient count is now correctly based on the
    // size of the filtered patient set.
    // =================================================================
    this.totalPatients = patientValueSets.size;

    // Step 2: Count patients sharing the same combination of values. This
    // naturally works on the filtered data because it uses `patientValueSets`.
    const intersectionCounts: { [key: string]: { sets: string[], count: number } } = {};
    for (const valueSet of patientValueSets.values()) {
      let sortedValues;
      if (this.matrixYaxisVar === 'CURRENT_REFERRAL_STATUS') {
        sortedValues = Array.from(valueSet).sort((a, b) => {
          const indexA = customStatusOrder.indexOf(a);
          const indexB = customStatusOrder.indexOf(b);
          return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
        });
      } else {
        sortedValues = Array.from(valueSet).sort();
      }

      const key = sortedValues.join('-');
      if (!intersectionCounts[key]) {
        intersectionCounts[key] = { sets: sortedValues, count: 0 };
      }
      // This count will now be the count from the filtered subset.
      intersectionCounts[key].count++;
    }

    // Step 3: Convert counts into a sorted array for D3.
    // This `processedData` now contains the newly calculated counts.
    this.processedData = Object.values(intersectionCounts)
      .sort((a, b) => b.count - a.count);

    // =================================================================
    // KEY CHANGE 3: The Y-axis labels (`sets`) must also be derived from
    // the filtered `sourceData` to hide any statuses/sources that no
    // longer exist in the filtered view.
    // =================================================================
    const allUniqueValues = new Set<string>();
    sourceData.forEach((record: any) => { // <-- Using `sourceData` here is also critical.
      // Apply deterministic "fluffing" filter here too for consistent Y-axis labels
      if (!this.shouldIncludeRecord(record)) return;

      if (record[this.matrixYaxisVar]) {
        allUniqueValues.add(record[this.matrixYaxisVar]);
      }
    });

    // Apply the same conditional sort to the Y-axis labels.
    if (this.matrixYaxisVar === 'CURRENT_REFERRAL_STATUS') {
      this.sets = Array.from(allUniqueValues).sort((a, b) => {
        const indexA = customStatusOrder.indexOf(a);
        const indexB = customStatusOrder.indexOf(b);
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
      });
    } else {
      this.sets = Array.from(allUniqueValues).sort();
    }
  }

  // NEW: A dedicated function to process the pre-aggregated journey stop data
  processJourneyStopData(): void {
    this.processData();
  }

  processJourneyStopData_Legacy(): void {
    // Check if `this.data` exists AND has the expected structure for Journey Stop data.
    // If `this.data` was loaded for "Sources" (patient journey records), it won't have `JOURNEY_SEQUENCE`.
    const isDynamicDataValid = this.data && this.data.length > 0 && 'JOURNEY_SEQUENCE' in this.data[0];
    const rawData = isDynamicDataValid ? this.data : journeyStopData;

    if (!rawData) return;

    // 1. Transform the data into the structure required by drawChart()
    this.processedData = rawData.map((item: any) => ({
      // Split the sequence string into an array of stops
      sets: item.JOURNEY_SEQUENCE.split(' -> ').map((s: string) => s.trim()),
      // Parse the patient count string into a number
      count: parseInt(item.PAT_COUNT, 10)
    }))
      .sort((a: any, b: any) => b.count - a.count); // Sort by count descending

    // 2. Calculate the total patient count for percentage calculations
    this.totalPatients = this.processedData.reduce((sum, item) => sum + item.count, 0);

    // 3. Get all unique journey stops for the Y-axis labels
    const allStops = new Set<string>();
    this.processedData.forEach(item => {
      item.sets.forEach(stop => allStops.add(stop));
    });
    this.sets = Array.from(allStops).sort(); // Sort alphabetically
  }

  // ===================================================================
  // D3 Rendering Method
  // ===================================================================

  /**
   * Handles all D3 logic for drawing and updating the chart.
   * This method is called on initial load and on every resize.
   */
  drawChart(): void {
    if (!this.processedData || !this.UpsetChartContainer) { return; }

    let dataToRender;
    if (this.isFiltered) { dataToRender = this.processedData.filter(d => this.selectedBars.has(d.sets.join('-'))); this.isOverflowing = false; } else { this.isOverflowing = this.processedData.length > 10; dataToRender = this.showMore ? this.processedData : this.processedData.slice(0, 10); }

    const element = this.UpsetChartContainer.nativeElement;
    const tooltip = d3.select(element.parentNode).select(".upset-tooltip");

    const margin = { left: 160, right: 30 };
    const barHeight = 350; // Fixed height for bar chart area

    // Determine the height of the scrollable container
    let matrixContainerHeight = 350;
    if (this.isFullscreen) {
      // In fullscreen, fill the rest of the screen (Window - TopBars - Headers/Padding)
      matrixContainerHeight = Math.max(350, window.innerHeight - barHeight - 150);
    }

    // Calculate matrix content height dynamically based on the number of rows
    const minRowHeight = 25;
    const calculatedMatrixHeight = this.sets.length * minRowHeight;

    // The SVG must be at least as tall as the container (to fill it if few rows)
    // or taller if there are many rows (to trigger scrolling)
    const matrixSvgHeight = Math.max(matrixContainerHeight, calculatedMatrixHeight);

    const minColumnWidth = 75;
    const availableWidth = element.offsetWidth - margin.left - margin.right;
    const requiredWidth = dataToRender.length * minColumnWidth;
    const chartWidth = Math.max(availableWidth, requiredWidth);

    // --- Update Bar SVG ---
    const barContainer = d3.select(element).select('.bar-section');
    barContainer
      .style("width", `${chartWidth + margin.left + margin.right}px`)
      .select('svg')
      .attr("width", chartWidth + margin.left + margin.right)
      .attr("height", barHeight);

    // --- Update Matrix SVG ---
    const matrixContainer = d3.select(element).select('.matrix-section');
    matrixContainer
      .style("width", `${chartWidth + margin.left + margin.right}px`)
      .style("height", `${matrixContainerHeight}px`) // Apply dynamic height to container
      .select('svg')
      .attr("width", chartWidth + margin.left + margin.right)
      .attr("height", matrixSvgHeight + 20); // +20 for bottom padding

    // --- Define a transition ---
    const t = d3.transition().duration(750);

    // --- Update Scales ---
    const yScaleBar = d3.scaleLinear().domain([0, d3.max(dataToRender, d => d.count) ?? 0]).nice().range([0, barHeight - 50]);
    const xScale = d3.scaleBand().domain(dataToRender.map(d => d.sets.join('-'))).range([0, chartWidth]).padding(0.6);
    // Important: The Y-scale for the matrix must use the SVG height (matrixSvgHeight)
    // BUT if we want evenly spaced rows when content < container, we should utilize the full container/svg height.
    const yScaleMatrix = d3.scaleBand().domain(this.sets).range([0, matrixSvgHeight]).padding(1);
    const colorScale = d3.scaleOrdinal(d3.schemeTableau10).domain(this.sets);

    // --- Update Axis Title Position ---
    this.yAxisTitle
      //.attr("y", 0 - margin.left + 90)
      .attr("y", 0 - margin.left + 20)
      // Position relative to the bar height
      .attr("x", (barHeight / 2));

    // --- Animate Bars (Enter-Update-Exit) ---
    const minBarHeight = 4;
    const bars = this.barGroup.selectAll(".bar")
      .data(dataToRender, d => d.sets.join('-')); // Key function is crucial for animations

    bars.exit()
      .transition(t)
      .attr("y", 0)
      .attr("height", 0)
      .remove();

    bars.enter()
      .append("rect")
      .attr("class", "bar")
      .style("cursor", "pointer")
      .attr("rx", 6).attr("ry", 6)
      .attr("fill", this.item?.config?.bar_color ?? '#cfe0fa')
      .merge(bars) // Merge enter and update selections
      .on("click", (event, d) => {
        const key = d.sets.join('-');
        if (this.selectedBars.has(key)) { this.selectedBars.delete(key); } else { this.selectedBars.add(key); }
        // Re-select all bars to update their class
        this.barGroup.selectAll('.bar').classed("selected", d => this.selectedBars.has(d.sets.join('-')));
        this.cdr.detectChanges();
      })
      .classed("selected", d => this.selectedBars.has(d.sets.join('-')))
      .transition(t) // Apply transition to both new and updating bars
      .attr("x", d => xScale(d.sets.join('-')))
      .attr("width", xScale.bandwidth())
      .attr("y", d => -Math.max(yScaleBar(d.count), minBarHeight))
      .attr("height", d => Math.max(yScaleBar(d.count), minBarHeight));

    // --- Animate Bar Labels (Enter-Update-Exit) ---
    const barLabels = this.barGroup.selectAll(".bar-label-group")
      .data(dataToRender, d => d.sets.join('-'));

    barLabels.exit()
      .transition(t)
      .style("opacity", 0)
      .remove();

    const barLabelsEnter = barLabels.enter()
      .append("g")
      .attr("class", "bar-label-group")
      .attr("text-anchor", "middle");

    barLabelsEnter.append("text").attr("class", "bar-label-count");
    barLabelsEnter.append("text").attr("class", "bar-label-percentage").attr("dy", "1.3em");

    const mergedLabels = barLabelsEnter.merge(barLabels);

    mergedLabels
      .transition(t)
      .attr("transform", d => `translate(${xScale(d.sets.join('-')) + xScale.bandwidth() / 2}, ${-Math.max(yScaleBar(d.count), minBarHeight) - 30})`);

    mergedLabels.select(".bar-label-count")
      .text(d => d.count.toLocaleString());

    mergedLabels.select(".bar-label-percentage")
      .text(d => this.totalPatients > 0 ? `${((d.count / this.totalPatients) * 100).toFixed(2)}%` : '0.00%');


    // --- Update Matrix (this part can also be animated, but for brevity we'll redraw) ---
    // A full enter-update-exit for the matrix is more complex. This redraws it quickly.
    this.matrixGroup.html(""); // Clear the matrix
    // No transform needed here as it's handled by the SVG group transform
    this.matrixGroup.selectAll(".row-background").data(this.sets).enter().append("rect").attr("class", "row-background").attr("x", -margin.left).attr("y", d => yScaleMatrix(d) - (yScaleMatrix.step() / 2)).attr("width", chartWidth + margin.left + margin.right).attr("height", yScaleMatrix.step()).attr("fill", (d, i) => (i % 2 === 1 ? "#f7f7f7" : "#ffffff"));
    this.matrixGroup.selectAll(".set-label")
      .data(this.sets)
      .enter()
      .append("text")
      .attr("class", "set-label")
      .attr("text-anchor", "end")
      .attr("x", -10)
      .attr("y", d => yScaleMatrix(d) + yScaleMatrix.bandwidth() / 2)
      .text(d => d.length > 20 ? d.substring(0, 20) + '...' : d)
      .style("fill", d => colorScale(d))
      .style("cursor", d => d.length > 20 ? "pointer" : "default")
      .on("mouseover", (event, d) => {
        if (d.length > 20) {
          const [x, y] = d3.pointer(event, element.parentNode);
          tooltip.style("opacity", 1);
          tooltip.html(`<strong>${d}</strong>`)
            .style("left", `${x + 15}px`)
            .style("top", `${y - 10}px`);
        }
      })
      .on("mousemove", (event, d) => {
        if (d.length > 20) {
          const [x, y] = d3.pointer(event, element.parentNode);
          tooltip
            .style("left", `${x + 15}px`)
            .style("top", `${y - 10}px`);
        }
      })
      .on("mouseout", () => {
        tooltip.style("opacity", 0);
      });
    const intersectionGroups = this.matrixGroup.selectAll(".intersection-group").data(dataToRender).enter().append("g").attr("class", "intersection-group").attr("transform", d => `translate(${xScale(d.sets.join('-')) + xScale.bandwidth() / 2}, 0)`);
    intersectionGroups.selectAll(".inactive-dot").data(d => this.sets.map(set => ({ setName: set }))).enter().append("circle").attr("class", "inactive-dot").attr("cy", d => yScaleMatrix(d.setName)).attr("r", 4);
    intersectionGroups.append("line").attr("class", "connection-line").filter(d => d.sets.length > 1).attr("y1", d => d3.min(d.sets.map(set => yScaleMatrix(set)))).attr("y2", d => d3.max(d.sets.map(set => yScaleMatrix(set)))).style("stroke", "#2f2f2f").style("stroke-width", "2.5px");
    intersectionGroups.selectAll(".active-dot")// The data join now includes the full sequence for context
      .data(d => d.sets.map(set => ({ setName: set, sequence: d.sets })))
      .enter()
      .append("circle")
      .attr("class", "active-dot")
      // Add this .classed() operator
      .classed("start-point", d => d.sequence[0] === d.setName)
      .attr("cy", d => yScaleMatrix(d.setName))
      .attr("r", 7).style("fill", d => colorScale(d.setName))
      .on("mouseover", (event, d) => { tooltip.style("opacity", 1); })
      .on("mousemove", (event, d) => {
        const [x, y] = d3.pointer(event, element.parentNode);
        tooltip.html(`Status: <strong>${d.setName}</strong>`)
          .style("left", `${x + 15}px`)
          .style("top", `${y - 10}px`);
      })
      .on("mouseout", (event, d) => { tooltip.style("opacity", 0); });
    //     intersectionGroups.selectAll(".active-dot").data(d => d.sets.map(set => ({ setName: set }))).enter().append("circle").attr("class", "active-dot").attr("cy", d => yScaleMatrix(d.setName)).attr("r", 7).style("fill", d => colorScale(d.setName)).on("mouseover", (event, d) => { tooltip.style("opacity", 1); }).on("mousemove", (event, d) => { tooltip.html(`Status: <strong>${d.setName}</strong>`).style("left", `${event.pageX + 15}px`).style("top", `${event.pageY - 10}px`); }).on("mouseout", (event, d) => { tooltip.style("opacity", 0); });

  }

  ngOnDestroy(): void {
    // clear payload

    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}